import React, { Component } from 'react'
import UserStore from 'stores/UserStore'
import RadioControl from 'components/RadioControl'
import ButtonControl from 'components/ButtonControl'
import ActionCreators from 'actions/ActionCreators'
import AnimakitExpander from 'animakit-expander'
import { createControlFactory } from 'components/Controls'
import classnames from 'classnames'
import { translate as t } from 'lang'
import { sendFeedback, saveInstantBookingEmail, dumpState } from 'api'
import isMobile from 'ismobilejs';

import './InstantBookingAwayModal.scss'

function getStateFromStores() {
    return {
        user: UserStore.getUser(),
    }
}

const ANIMATION_DURATION = 100
const REASON_JUST_SHOW_PRICE = 3
const REASON_TOO_EXPENSIVE = 4
const REASON_NEED_HELP = 5

class InstantBookingAwayModal extends Component {

    constructor(props) {
        super(props)
        const storeStates = getStateFromStores()

        this.state = {
            ...storeStates,
            reasonForLeaving: 0,
            showModalForm: true,
            showModalThanks: false,
            showModalEmail: false,
            showModalNoEmailJustShowPrice: false,
            showModalPromocode: false,
            showModalNoEmailPromocode: false,
            showModalMobile: false,
            emailWasSkipped: !storeStates.user.email.value,
            error: '',
        }

        this.Control = createControlFactory(ActionCreators.updateUser)
    }

    _onChange = () => {
        this.setState(getStateFromStores())
    }

    componentDidMount() {
        UserStore.addChangeListener(this._onChange)
    }

    componentWillUnmount() {
        UserStore.removeChangeListener(this._onChange)
    }

    onChangeFeedbackRadio = (event) => {
        this.setState({
            reasonForLeaving: parseInt(event.target.value, 10),
        })
    }

    onChangePhone = () => {
        this.setState({
            errorPhone: '',
        })
    }

    onChangeEmail = () => {
        this.setState({
            errorEmail: '',
        })
    }

    processFeedback = () => {
        const email = this.state.user.email.value
        let newState = {
            showModalForm: false,
        }
        let doSend = false

        switch (this.state.reasonForLeaving) {
            case REASON_TOO_EXPENSIVE:
                if (email) {
                    newState.showModalPromocode = true
                    doSend = true
                } else {
                    newState.showModalNoEmailPromocode = true
                }
                break
            case REASON_JUST_SHOW_PRICE:
                if (email) {
                    doSend = true
                    newState.showModalEmail = true
                } else {
                    newState.showModalNoEmailJustShowPrice = true
                }
                break
            case REASON_NEED_HELP:
                newState.showModalMobile = true
                break
        }

        this.setState(newState)

        if (doSend) {
            this.sendFeedback()
        }
    }

    showThanks = () => {
        this.setState({
            showModalThanks: true,
            showModalForm: false,
            showModalNoEmailJustShowPrice: false,
            showModalPromocode: false,
            showModalNoEmailPromocode: false,
            showModalMobile: false,
        })
    }

    sendFeedback = () => {

        ActionCreators.showLoadingOverlay()

        return sendFeedback(
            this.state.reasonForLeaving,
            this.state.user.phone_mobile.value,
            this.state.user.email.value,
        )
            .then(result => {
                if (result.success === 1) {
                    switch (this.state.reasonForLeaving) {
                        case REASON_JUST_SHOW_PRICE:
                            this.setState({
                                showModalThanks: false,
                                showModalForm: false,
                                showModalNoEmailJustShowPrice: false,
                                showModalPromocode: false,
                                showModalNoEmailPromocode: false,
                                showModalMobile: false,
                                showModalEmail: true,
                            })
                            break
                        case REASON_TOO_EXPENSIVE:
                            this.setState({
                                showModalThanks: false,
                                showModalForm: false,
                                showModalNoEmailJustShowPrice: false,
                                showModalPromocode: true,
                                showModalNoEmailPromocode: false,
                                showModalMobile: false,
                                showModalEmail: false,
                            })
                            break
                        default:
                            this.showThanks()
                    }

                    return true
                } else if (result.success === 0 && (result.phone || result.email)) {
                    const newState = {}

                    if (result.phone) {
                        newState.errorPhone = result.phone
                    }

                    if (result.email) {
                        newState.errorEmail = result.email
                    }

                    this.setState(newState)
                    return false
                } else {
                    dumpState()
                    alert(t('SOMETHING_WENT_WRONG'))
                    return false
                }
            })
            .then(result => {
                const email = this.state.user.email.value

                if (result && email && this.state.emailWasSkipped) {
                    return saveInstantBookingEmail(email)
                        .then(result => {
                            if (result.success) {
                                ActionCreators.updateUser({
                                    has_account: Boolean(result.has_account),
                                })

                                // if (result.has_account) {
                                //     ActionCreators.showInstantBookingGoToAuctionButton()
                                // } else if (this.state.selectedCategory.name === 'household' || this.state.selectedCategory.name === 'moving') {
                                //     ActionCreators.hideInstantBookingGoToAuctionButton()
                                // }
                            }

                            return Boolean(result.success)
                        })
                        .catch(() => {
                            return false
                        })
                }

                return true
            })
            .catch(() => {
                dumpState()
                alert(t('SOMETHING_WENT_WRONG'))
                return false
            })
            .finally(() => {
                ActionCreators.hideLoadingOverlay()
            })
    }

    closeFeedbackModal = () => {
        ActionCreators.hideInstantBookingAwayModal()
    }

    render() {
        const feedbackModalClass = classnames(
            'InstantBookingAwayModal__modal',
            'InstantBookingAwayModal__modal--show',
        )

        const user = this.state.user
        const email = user.email.value

        return (
            <div className={feedbackModalClass}>
                <div className="InstantBookingAwayModal__modal-body">
                    <div className="InstantBookingAwayModal__modal-close" onClick={this.closeFeedbackModal}>Закрыть
                    </div>
                    <AnimakitExpander expanded={this.state.showModalForm} duration={ANIMATION_DURATION}>
                        <div className="InstantBookingAwayModal__modal-info">
                            Уточните, пожалуйста, почему вы&nbsp;решили уйти. Это поможет сделать наш сервис лучше!
                        </div>
                        <div>
                            <RadioControl name="reason_for_leaving"
                                className="InstantBookingAwayModal__modal-radio"
                                label={<span>Хотелось узнать цену перевозки</span>}
                                value="3"
                                checked={REASON_JUST_SHOW_PRICE === this.state.reasonForLeaving}
                                onChange={this.onChangeFeedbackRadio} />
                            <RadioControl name="reason_for_leaving"
                                className="InstantBookingAwayModal__modal-radio"
                                label={<span>Дороже, чем ожидалось</span>}
                                value="4"
                                checked={REASON_TOO_EXPENSIVE === this.state.reasonForLeaving}
                                onChange={this.onChangeFeedbackRadio} />
                            <RadioControl name="reason_for_leaving"
                                className="InstantBookingAwayModal__modal-radio"
                                label={<span>Сложно разобраться в работе {isMobile.phone && <br />} сайта (системы, сервиса)</span>}
                                value="5"
                                checked={REASON_NEED_HELP === this.state.reasonForLeaving}
                                onChange={this.onChangeFeedbackRadio} />
                        </div>
                        <ButtonControl className="InstantBookingAwayModal__modal-button"
                            view="forest"
                            size="s"
                            disabled={this.state.reasonForLeaving === 0}
                            onClick={this.processFeedback}>
                            OK
                        </ButtonControl>
                    </AnimakitExpander>
                    <AnimakitExpander expanded={this.state.showModalThanks} duration={ANIMATION_DURATION}>
                        <div className="InstantBookingAwayModal__modal-thanks">Спасибо!</div>
                    </AnimakitExpander>
                    <AnimakitExpander expanded={this.state.showModalEmail} duration={ANIMATION_DURATION}>
                        <div className="InstantBookingAwayModal__modal-thanks">
                            На вашу электронную почту мы отправили письмо с расчетом окончательной цены вашей перевозки,
                            будем рады видеть вас снова.
                        </div>
                    </AnimakitExpander>
                    <AnimakitExpander expanded={this.state.showModalNoEmailJustShowPrice} duration={ANIMATION_DURATION}>
                        <div className="InstantBookingAwayModal__modal-mobile-wrapper">
                            <div className="InstantBookingAwayModal__modal-mobile-text">
                                Укажите ваш email, и мы отправим письмо с расчетом окончательной цены вашей перевозки
                            </div>
                            <div className="InstantBookingAwayModal__modal-form-block">
                                <this.Control
                                    type="text"
                                    attribute={user.email}
                                    name="email"
                                    placeholder="email@example.com"
                                    label=""
                                    htmlType="email"
                                    onChange={this.onChangeEmail}
                                    value={email}
                                    error={t(this.state.errorEmail)} />
                                <ButtonControl className="InstantBookingAwayModal__modal-button-form"
                                    view="forest"
                                    size="s"
                                    onClick={this.sendFeedback}>
                                    Хорошо
                                </ButtonControl>
                            </div>
                        </div>
                    </AnimakitExpander>
                    <AnimakitExpander expanded={this.state.showModalNoEmailPromocode} duration={ANIMATION_DURATION}>
                        <div className="InstantBookingAwayModal__modal-mobile-wrapper">
                            <div className="InstantBookingAwayModal__modal-mobile-text">
                                Укажите ваш email, и мы пришлем вам промокод на скидку для вашей перевозки
                            </div>
                            <div className="InstantBookingAwayModal__modal-form-block">
                                <this.Control
                                    type="text"
                                    attribute={user.email}
                                    name="email"
                                    placeholder="email@example.com"
                                    label=""
                                    htmlType="email"
                                    onChange={this.onChangeEmail}
                                    value={email}
                                    error={t(this.state.errorEmail)} />
                                <ButtonControl className="InstantBookingAwayModal__modal-button-form"
                                    view="forest"
                                    size="s"
                                    onClick={this.sendFeedback}>
                                    Хорошо
                                </ButtonControl>
                            </div>
                        </div>
                    </AnimakitExpander>
                    <AnimakitExpander expanded={this.state.showModalPromocode} duration={ANIMATION_DURATION}>
                        <div className="InstantBookingAwayModal__modal-thanks">
                            Мы отправили промокод на {email}, который даст скидку на вашу перевозку!
                        </div>
                    </AnimakitExpander>
                    <AnimakitExpander expanded={this.state.showModalMobile} duration={ANIMATION_DURATION}>
                        <div className="InstantBookingAwayModal__modal-mobile-wrapper">
                            <div className="InstantBookingAwayModal__modal-mobile-text">
                                Мы&nbsp;поможем вам, оставьте свой номер телефона или перезвоните нам на&nbsp;бесплатный
                                номер <strong><a href="tel:88005551923">8&nbsp;800&nbsp;555&nbsp;1923</a></strong>
                            </div>
                            <div className="InstantBookingAwayModal__modal-form-block">
                                <this.Control
                                    type="tel"
                                    attribute={user.phone_mobile}
                                    name="phone_mobile"
                                    onChange={this.onChangePhone}
                                    label=""
                                    error={t(this.state.errorPhone)} />
                                <ButtonControl className="InstantBookingAwayModal__modal-button-form"
                                    view="forest"
                                    size="s"
                                    onClick={this.sendFeedback}>
                                    Хорошо
                                </ButtonControl>
                            </div>
                        </div>
                    </AnimakitExpander>
                </div>
                <div className="InstantBookingAwayModal__modal-backdrop" onClick={this.closeFeedbackModal} />
            </div>
        )
    }
}

export default InstantBookingAwayModal



// WEBPACK FOOTER //
// ./client/components/InstantBookingAwayModal/InstantBookingAwayModal.js